// If we don't want to hard code these we can fetch them from an API.
// may be especially true as we change subscriptions/prices
export function getStripeProductID(
  type: 'free' | 'pro' | 'more' | 'advanced' | 'unlimited',
) {
  // if subdomain exists grab test tokens otherwise use prod tokens
  const subdomain = window.location.hostname.replace('www.', '').split('.')[0];
  if (subdomain !== 'getcartwheel' && subdomain !== 'studio') {
    // These are test Product IDs
    // return type
    switch (type) {
      case 'pro':
        return 'prod_OPQ1iJsg3xyXFC';
      case 'free':
        return 'prod_OPQ0y8WKSQaIyS';
      case 'more':
        return 'prod_QJR6cZX3JOkQRD';
      case 'advanced':
      case 'unlimited':
        return 'prod_SJKTimlhA1znLP';
    }
  } else {
    // return type
    switch (type) {
      case 'pro':
        return 'prod_OPPy42smdkSGxv';
      case 'free':
        return 'prod_OPPw8svBGpvlgT';
      case 'more':
        return 'prod_QJR5g5xLYmu3lh';
      case 'advanced':
      case 'unlimited':
        return 'prod_SJKWHR5xdTAqzW';
    }
  }
}
